import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { account } from './modules/account';
import { subscriptions } from './modules/subscriptions';
import { orders } from './modules/orders';
import { products } from './modules/products';
import { bulletins } from './modules/bulletins';
import { members } from './modules/members';
import { config } from './modules/config';
import { services } from './modules/services';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  // strictMode: true,
  storage: localStorage,
  supportCircular: true,
  reducer: (state) => ({
    account: state.account,
    orders: state.orders,
    config: state.config,
    services: state.services
  })
});

export const store = new Vuex.Store({
  modules: {
    account,
    subscriptions,
    orders,
    products,
    bulletins,
    members,
    config,
    services
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION
  }
});
